// extracted by mini-css-extract-plugin
export default {"askBubble":"AskAssistantBubble_askBubble__9Lugs","askBubbleIcon":"AskAssistantBubble_askBubbleIcon__0Mgnn"};